/**
 * AnimationHelper — Utility for staggered entrance animations.
 */
export default class AnimationHelper {
  /**
   * Add staggered entrance animation to a set of elements.
   * @param {string} selector - CSS selector for elements to animate
   * @param {number} delayMs - Delay between each element in milliseconds
   */
  static staggerEnter(selector, delayMs = 50) {
    const elements = document.querySelectorAll(selector);
    elements.forEach((el, idx) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(12px)';

      setTimeout(() => {
        el.style.transition = 'opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1), transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      }, idx * delayMs + 100); // +100ms initial delay
    });
  }

  /**
   * Fade in a single element.
   */
  static fadeIn(element, durationMs = 300) {
    if (!element) return;
    element.style.opacity = '0';
    element.style.transition = `opacity ${durationMs}ms ease`;

    requestAnimationFrame(() => {
      element.style.opacity = '1';
    });
  }

  /**
   * Scale in a single element (for modals, expanded panels).
   */
  static scaleIn(element, durationMs = 200) {
    if (!element) return;
    element.style.opacity = '0';
    element.style.transform = 'scale(0.96)';
    element.style.transition = `opacity ${durationMs}ms ease, transform ${durationMs}ms ease`;

    requestAnimationFrame(() => {
      element.style.opacity = '1';
      element.style.transform = 'scale(1)';
    });
  }
}
